import moment from "moment";

export class SocketBackoff {

    private retryAttempts = 0;

    private lastFailure: number | null = null;

    public reset() {
        this.retryAttempts = 0;
        this.lastFailure = null;
    }

    public getNextBackoff() {
        const now = moment.now();

        if (this.lastFailure && (now - this.lastFailure) > 60_000) {
            this.retryAttempts = 0;
        }

        this.retryAttempts += 1;

        switch (this.retryAttempts) {
            case 0:
            case 1:
                return 1_000;
            case 2:
                return 5_000;
            case 3:
                return 10_000;
            default:
                return 30_000;
        }
    }
}
